import * as moment from "moment";
import * as React from "react";

export const Footer: React.FC = () => (
    <footer
        className="app-footer flex justify-center"
    >
        {BQS ? "A Brent Material Product." : "Caterina Supply INC."} ©{" "}
        {moment().format("YYYY")} All Rights Reserved.
    </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./ClientApp/components/Footer.tsx